import { Tooltip } from "@findemdev/maui";
import { createContext, useContext, type ReactNode } from "react";
import { COLLABORATOR_UNSUPPORTED_MESSAGE } from "./collaboration";

const RaasProjectCollaborationContext = createContext({
  isCollaborator: false,
  canManageCollaborators: false,
});
export const RaasProjectCollaborationProvider =
  RaasProjectCollaborationContext.Provider;
export const useRaasProjectCollaboration = () =>
  useContext(RaasProjectCollaborationContext);

export const CollaboratorUnsupportedTooltip = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { isCollaborator } = useRaasProjectCollaboration();
  return isCollaborator ? (
    <Tooltip title={COLLABORATOR_UNSUPPORTED_MESSAGE}>
      <span tabIndex={0} style={{ display: "inline-flex" }}>
        {children}
      </span>
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
